import { Badge } from "flowbite-react";
import { ImagePlaceholder } from "../icons";

const DeclinedRequestDetail = ({ request, merch }) => {
  const item = merch.find((m) => m.id === request.item_id);

  return (
    <div className="flex flex-col gap-4 h-full">
      {/* ── Header ── */}
      <div className="flex items-start justify-between">
        <div>
          <h3 className="text-base font-bold text-gray-900 dark:text-white leading-tight">
            Request details
          </h3>
          <p className="text-xs text-gray-400 mt-0.5">
            by {request.requester_name ?? request.requested_by}
          </p>
        </div>
        <div className="flex flex-col items-end gap-1">
          <Badge color="failure" size="xs">
            declined
          </Badge>
          {request.declined_at && (
            <p className="text-[11px] text-gray-400 whitespace-nowrap">
              {request.declined_at.toDate().toLocaleDateString("en-AU", {
                day: "numeric",
                month: "short",
                year: "numeric",
              })}
            </p>
          )}
        </div>
      </div>

      {/* ── Item preview ── */}
      <div className="flex gap-3 items-center rounded-xl bg-gray-50 dark:bg-gray-800 p-3">
        {item?.assets?.[0] ? (
          <img
            src={item.assets[0].url}
            alt={item.item_name}
            className="w-14 h-14 rounded-lg object-cover shrink-0"
          />
        ) : (
          <div className="w-14 h-14 rounded-lg bg-gray-200 dark:bg-gray-700 flex items-center justify-center shrink-0">
            <ImagePlaceholder />
          </div>
        )}
        <div className="flex flex-col justify-center min-w-0 gap-1">
          <p className="font-semibold text-gray-900 dark:text-white text-sm truncate">
            {request.item_name ?? item?.item_name ?? "Unknown item"}
          </p>
          {item && (
            <p className="text-xs text-gray-400">
              {item.item_count} remaining in stock
            </p>
          )}
        </div>
      </div>

      {/* ── Request info ── */}
      <div className="grid grid-cols-2 gap-2">
        <div className="rounded-lg bg-gray-50 dark:bg-gray-800 px-3 py-2">
          <p className="text-xs text-gray-400 mb-1">Requested</p>
          <p className="text-xl font-bold text-gray-900 dark:text-white">
            {request.item_count}
            <span className="text-xs font-normal text-gray-400 ml-1">
              items
            </span>
          </p>
        </div>
        <div className="rounded-lg bg-gray-50 dark:bg-gray-800 px-3 py-2">
          <p className="text-xs text-gray-400 mb-1">Purpose</p>
          <p className="text-sm font-medium text-gray-900 dark:text-white truncate">
            {request.purpose || (
              <span className="text-gray-400 font-normal">—</span>
            )}
          </p>
        </div>
      </div>

      {/* ── Declined by ── */}
      <div className="rounded-lg bg-gray-50 dark:bg-gray-800 px-3 py-2">
        <p className="text-xs text-gray-400 mb-1">Declined by</p>
        <p className="text-sm font-medium text-gray-900 dark:text-white">
          {request.declined_by ?? "—"}
        </p>
      </div>

      {/* ── Decline reason ── */}
      {request.decline_reason && (
        <div className="rounded-lg bg-red-50 dark:bg-red-950 border border-red-100 dark:border-red-900 px-3 py-2">
          <p className="text-xs text-red-400 mb-1">Reason</p>
          <p className="text-sm text-red-700 dark:text-red-300">
            {request.decline_reason}
          </p>
        </div>
      )}

      {/* ── Note ── */}
      {request.note && (
        <div className="rounded-lg bg-gray-50 dark:bg-gray-800 px-3 py-2">
          <p className="text-xs text-gray-400 mb-1">Note</p>
          <p className="text-sm text-gray-900 dark:text-white">
            {request.note}
          </p>
        </div>
      )}
    </div>
  );
};

export default DeclinedRequestDetail;
